import InitialQuestions from './initial/questions';
import FollowupQuestions from './followup/questions';
import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const alcoholQuestions = [...InitialQuestions, ...FollowupQuestions];
export default alcoholQuestions;

const _type = [...alcoholQuestions];
export type AlcoholFieldAnswers = Partial<QuestionAnswerMap<typeof _type>>;
